import React from 'react';
import { Box } from '@mui/material';
import { PixelStreamingWrapper } from './PixelStreamingWrapper';

const MytaStreams = () => {
  return (
    <Box>
      <PixelStreamingWrapper />
    </Box>
  );
};

export default MytaStreams;
